import { render } from "./CustomerSelect.vue?vue&type=template&id=3c6794c0&ts=true"
import script from "./CustomerSelect.vue?vue&type=script&lang=ts"
export * from "./CustomerSelect.vue?vue&type=script&lang=ts"

import "./CustomerSelect.vue?vue&type=style&index=0&id=3c6794c0&lang=scss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__